export const CLOSED_PROGRESS_TYPES = ['CL', 'CD'] as const

export type ClosedProgressType = (typeof CLOSED_PROGRESS_TYPES)[number]

export const NO_STATUS_SENTINEL_ID = '__no_status__' as const

export const isClosedProgressType = (
  progressType: string | null | undefined,
): progressType is ClosedProgressType =>
  progressType != null &&
  CLOSED_PROGRESS_TYPES.includes(progressType as ClosedProgressType)

// Task details layout constants
export const TASK_DETAILS_LAYOUT = {
  HORIZONTAL: 'horizontal',
  SIDEBAR: 'sidebar',
  /** Full page (design 28a): reading column with a sticky property column. */
  PAGE: 'page',
} as const

export type TaskDetailsLayout = (typeof TASK_DETAILS_LAYOUT)[keyof typeof TASK_DETAILS_LAYOUT]
